import { customTheme } from '@/config/theme'
import { cartoThemeOptions } from '@carto/meridian-ds/theme'
import { createTheme, type ThemeOptions } from '@mui/material'

export const theme = createTheme(
  cartoThemeOptions as ThemeOptions,
  // The cast asserts only what `customTheme` reads (a full palette and typography), which Meridian's
  // options do carry. It used to claim they were a whole `Theme`, and that is the claim that let a
  // `theme.spacing()` into config/theme.ts and blanked the app (§118).
  customTheme(
    cartoThemeOptions as unknown as Parameters<typeof customTheme>[0],
  ),
)
